import { OperationAbortedError, throwApiError } from 'src/packages/errors';

import type { TTableSettings } from './table-settings-service';
import type { AxiosInstance } from 'axios';

export class TableSettingsServiceApi {
  private readonly agent: AxiosInstance;
  private updateTableSettingsAbortController: AbortController | null = null;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  async loadSettings(signal?: AbortSignal): Promise<TTableSettings> {
    try {
      const { data } = await this.agent.get('userSettings/table', {
        signal,
      });

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async updateSettings(newSettings: TTableSettings, signal?: AbortSignal): Promise<void> {
    if (this.updateTableSettingsAbortController) {
      this.updateTableSettingsAbortController.abort();
    }

    const abortController = new AbortController();
    this.updateTableSettingsAbortController = abortController;

    try {
      await this.agent.patch('userSettings/table', newSettings, { signal: abortController.signal });
    } catch (e) {
      if (e instanceof OperationAbortedError) {
        return;
      }

      throwApiError(e);
    } finally {
      this.updateTableSettingsAbortController = null;
    }
  }

  async createSettings(settings: TTableSettings): Promise<{ id: number }> {
    try {
      const { data } = await this.agent.post('userSettings/table', settings);

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }
}
